import styled from '@emotion/styled'
import {Add} from '@mui/icons-material'
import React from 'react'
import {ZIndex} from '~/types/constEnums'
import FloatingActionButton from './FloatingActionButton'

const Button = styled(FloatingActionButton)({
  color: '#fff',
  padding: '10px 12px',
  minWidth: '150px',
  bottom: 16,
  right: 16,
  position: 'absolute',
  zIndex: ZIndex.FAB
})

const StyledIcon = styled(Add)({
  marginRight: 8
})

const StyledLabel = styled('div')({
  fontSize: 16,
  fontWeight: 600
})






const NewIntegrationRecordButton = (props) => {
  const {labelText, onClick} = props
  return (
    React.createElement(Button, { onClick: onClick, palette: "blue",}
      , React.createElement(StyledIcon, null )
      , React.createElement(StyledLabel, null, labelText)
    )
  )
}

export default NewIntegrationRecordButton
